import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';
import {transparentize} from 'polished';

export const Wrapper = styled(BoxContainer)`
  display: block;
`;

export const Header = styled.label`
  cursor: pointer;
  padding: 20px 15px;
  column-gap: 10px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Title = styled.span`
  padding: 0 5px;
  
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  user-select: none;
`;

export const Description = styled.p`
  margin: 0 0 20px 0;
  padding: 0 5px;
  
  color: ${({theme}) => `
    ${transparentize(.4, theme.variables.color)};
  `};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const Content = styled.div`
  padding: 0 15px 20px 15px;
`;
